import { Routes, RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { HttpClientModule } from "@angular/common/http";

import { AppComponent } from "./app.component";
import { AuthModule } from "./auth/auth.module";
import { MainModule } from "./main/main.module";
import { httpInterceptorProviders } from "./common/interceptors/interceptors";
import { CommonService } from "./common/common.service";
import { NetworkService } from "./common/network.service";
import { ConfirmationComponent } from "./common/components/confirmation/confirmation.component";
import { AuthGuardMain } from "./auth/auth-guard.service";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { GoogleplaceDirective } from './common/directive/googleplace.directive';
import { AgmCoreModule } from '@agm/core';
import { ExcelService } from './main/dashboard/excel.service';
import { TextareaAutosizeModule } from 'ngx-textarea-autosize';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



const routes: Routes = [{ path: "", redirectTo: "auth/login", pathMatch: "full" }];

@NgModule({
  declarations: [AppComponent, ConfirmationComponent, GoogleplaceDirective],
  imports: [
    BrowserModule,
    AuthModule,
    MainModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    NgbModule,
    NgxChartsModule,
    TextareaAutosizeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCfje1j4_X9qedDgAsCtjU52KYJg1yfYzI',
      libraries: ['places', 'geometry']
    }),
  ],
  providers: [httpInterceptorProviders, CommonService, NetworkService, AuthGuardMain, ExcelService],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationComponent]
})
export class AppModule { }
